const priceUnits = {
	FIXED: "fixed",
	TIME: "time",
	HOUR: "hour",
	ACTIVITY: "activity",
	PERCENTAGE: "percentage",
	// Cloud revenue prices: per work and year.
	YEAR: "year",
};

export default priceUnits;
